import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Main } from '@/components/layout/main'
import { UnifiedHeader } from '@/components/layout/unified-header'
import { FnsProvider } from '@/features/forms-and-surveys/contexts/fns-context'

export const Route = createFileRoute('/_authenticated/forms')({
  component: SurveysLayout,
})

function SurveysLayout() {
  return (
    <FnsProvider mode='form'>
      <UnifiedHeader />
      <Main>
        <Outlet />
      </Main>
    </FnsProvider>
  )
}
